export default {
  refund_task: {
    statuses: {
      pending: '审核中',
      passed: '已退款',
      rejected: '已拒绝',
      closed: '已取消'
    }
  }
}
